import React, { useState } from 'react';
import { CommandCenterLayout } from '../../components/layout/CommandCenterLayout';
import { Card, CardContent } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Badge } from '../../components/ui/Badge';
import { Input } from '../../components/ui/Input';
import { Textarea } from '../../components/ui/Textarea';
import { Check, X, ExternalLink, Calendar, User, MapPin, AlertCircle, RefreshCw, Image as ImageIcon, AlertTriangle } from 'lucide-react';
// Mock Validation Queue
const mockQueue = [{
  id: 'EVD-001',
  campaign: 'Kampanye HPSN 2025',
  receiver: 'Dinas LH Kota Surabaya',
  platform: 'Instagram',
  url: 'https://instagram.com/p/123456',
  submittedAt: '2025-02-12 10:30',
  status: 'submitted',
  screenshot: 'https://placehold.co/400x600/png?text=Screenshot+Bukti',
  notes: '',
  similarityScore: 92 // Mock AI similarity score
}, {
  id: 'EVD-002',
  campaign: 'Kampanye HPSN 2025',
  receiver: 'Komunitas Peduli Sampah Bandung',
  platform: 'TikTok',
  url: 'https://tiktok.com/@komunitas/video/123',
  submittedAt: '2025-02-12 11:15',
  status: 'submitted',
  screenshot: 'https://placehold.co/400x600/png?text=Screenshot+TikTok',
  notes: '',
  similarityScore: 45 // Low similarity warning
}];
export function ValidasiPostingPage() {
  const [queue, setQueue] = useState(mockQueue);
  const [currentItemIndex, setCurrentItemIndex] = useState(0);
  const [rejectReason, setRejectReason] = useState('');
  const [isRejecting, setIsRejecting] = useState(false);
  const currentItem = queue[currentItemIndex];
  const handleNext = () => {
    if (currentItemIndex < queue.length - 1) {
      setCurrentItemIndex(currentItemIndex + 1);
      setIsRejecting(false);
      setRejectReason('');
    } else {
      // End of queue
      setQueue([]);
    }
  };
  const handleValidate = () => {
    // API call to validate
    // alert(`Validated item ${currentItem.id}`)
    handleNext();
  };
  const handleReject = () => {
    if (!rejectReason) {
      alert('Mohon isi alasan penolakan');
      return;
    }
    // API call to reject
    // alert(`Rejected item ${currentItem.id} reason: ${rejectReason}`)
    handleNext();
  };
  if (!currentItem) {
    return <CommandCenterLayout title="Validasi Posting" data-id="element-2661">
        <div className="flex flex-col items-center justify-center h-[60vh] text-center" data-id="element-2662">
          <div className="p-4 bg-green-100 rounded-full mb-4" data-id="element-2663">
            <Check className="h-8 w-8 text-green-600" data-id="element-2664" />
          </div>
          <h3 className="text-xl font-bold text-gray-900" data-id="element-2665">
            Semua Tugas Selesai!
          </h3>
          <p className="text-gray-500 mt-2" data-id="element-2666">
            Tidak ada antrian validasi saat ini.
          </p>
          <Button className="mt-4" onClick={() => window.location.reload()} data-id="element-2667">
            <RefreshCw className="h-4 w-4 mr-2" data-id="element-2668" /> Refresh Data
          </Button>
        </div>
      </CommandCenterLayout>;
  }
  return <CommandCenterLayout title="Validasi Posting" subtitle="Verifikasi bukti tayang konten dari penerima" data-id="element-2669">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 h-[calc(100vh-140px)]" data-id="element-2670">
        {/* Left: Content Preview */}
        <div className="lg:col-span-2 flex flex-col gap-4" data-id="element-2671">
          <Card className="flex-1 flex flex-col overflow-hidden" data-id="element-2672">
            <div className="bg-gray-100 p-4 border-b flex justify-between items-center" data-id="element-2673">
              <div className="flex items-center gap-2" data-id="element-2674">
                <Badge variant="outline" className="bg-white" data-id="element-2675">
                  {currentItem.platform}
                </Badge>
                <a href={currentItem.url} target="_blank" rel="noreferrer" className="text-sm text-blue-600 hover:underline flex items-center gap-1" data-id="element-2676">
                  Buka Link Asli <ExternalLink className="h-3 w-3" data-id="element-2677" />
                </a>
              </div>
              <span className="text-xs text-gray-500" data-id="element-2678">
                Submitted: {currentItem.submittedAt}
              </span>
            </div>

            <div className="flex-1 bg-gray-50 p-4 flex items-center justify-center overflow-auto relative" data-id="element-2679">
              {/* Simulation of Embed or Screenshot */}
              <div className="max-w-md w-full bg-white shadow-lg rounded-lg overflow-hidden border" data-id="element-2680">
                <img src={currentItem.screenshot} alt="Proof" className="w-full h-auto object-contain max-h-[500px]" data-id="element-2681" />
                <div className="p-4" data-id="element-2682">
                  <p className="text-sm text-gray-500 italic text-center" data-id="element-2683">
                    Preview Screenshot (Klik link asli untuk melihat konten
                    live)
                  </p>
                </div>
              </div>

              {/* Similarity Warning Overlay */}
              {currentItem.similarityScore < 50 && <div className="absolute top-4 right-4 bg-red-100 text-red-800 px-3 py-2 rounded-lg border border-red-200 shadow-sm flex items-center gap-2 text-sm font-medium" data-id="element-2684">
                  <AlertTriangle className="h-4 w-4" data-id="element-2685" />
                  Low Similarity ({currentItem.similarityScore}%)
                </div>}
            </div>
          </Card>
        </div>

        {/* Right: Validation Controls */}
        <div className="flex flex-col gap-4" data-id="element-2686">
          <Card data-id="element-2687">
            <CardContent className="p-6 space-y-6" data-id="element-2688">
              <div data-id="element-2689">
                <h3 className="font-bold text-gray-900 text-lg mb-1" data-id="element-2690">
                  {currentItem.receiver}
                </h3>
                <div className="flex items-center gap-2 text-sm text-gray-500 mb-4" data-id="element-2691">
                  <MapPin className="h-4 w-4" data-id="element-2692" /> Jawa Timur
                </div>

                <div className="p-3 bg-blue-50 rounded-lg border border-blue-100 space-y-2" data-id="element-2693">
                  <div className="text-xs text-blue-800 font-medium uppercase tracking-wider" data-id="element-2694">
                    Campaign
                  </div>
                  <div className="text-sm font-medium text-blue-900" data-id="element-2695">
                    {currentItem.campaign}
                  </div>
                </div>
              </div>

              <div className="space-y-3 pt-4 border-t" data-id="element-2696">
                <div className="flex justify-between text-sm" data-id="element-2697">
                  <span className="text-gray-500" data-id="element-2698">Target Platform</span>
                  <span className="font-medium" data-id="element-2699">{currentItem.platform}</span>
                </div>
                <div className="flex justify-between text-sm" data-id="element-2700">
                  <span className="text-gray-500" data-id="element-2701">Status Akun</span>
                  <span className="text-green-600 font-medium flex items-center gap-1" data-id="element-2702">
                    <Check className="h-3 w-3" data-id="element-2703" /> Terverifikasi
                  </span>
                </div>
                <div className="flex justify-between text-sm" data-id="element-2704">
                  <span className="text-gray-500" data-id="element-2705">AI Check</span>
                  <span className={`font-medium flex items-center gap-1 ${currentItem.similarityScore >= 80 ? 'text-green-600' : 'text-yellow-600'}`} data-id="element-2706">
                    {currentItem.similarityScore}% Match
                  </span>
                </div>
              </div>

              <div className="pt-6 border-t space-y-3" data-id="element-2707">
                {!isRejecting ? <>
                    <Button className="w-full bg-green-600 hover:bg-green-700 text-white h-12 text-lg" onClick={handleValidate} data-id="element-2708">
                      <Check className="h-5 w-5 mr-2" data-id="element-2709" /> Validasi (Approve)
                    </Button>
                    <Button variant="outline" className="w-full border-red-200 text-red-600 hover:bg-red-50 h-12" onClick={() => setIsRejecting(true)} data-id="element-2710">
                      <X className="h-5 w-5 mr-2" data-id="element-2711" /> Tolak (Reject)
                    </Button>
                  </> : <div className="space-y-3 animate-in fade-in slide-in-from-bottom-2" data-id="element-2712">
                    <label className="text-sm font-medium text-gray-700" data-id="element-2713">
                      Alasan Penolakan:
                    </label>
                    <div className="space-y-2" data-id="element-2714">
                      {['Link tidak bisa dibuka', 'Konten tidak sesuai', 'Bukan akun resmi', 'Tanggal posting salah'].map(reason => <div key={reason} className={`p-2 border rounded cursor-pointer text-sm ${rejectReason === reason ? 'bg-red-50 border-red-500 text-red-700' : 'hover:bg-gray-50'}`} onClick={() => setRejectReason(reason)} data-id="element-2715">
                          {reason}
                        </div>)}
                    </div>
                    <Textarea placeholder="Atau tulis alasan spesifik..." value={rejectReason} onChange={e => setRejectReason(e.target.value)} data-id="element-2716" />
                    <div className="flex gap-2" data-id="element-2717">
                      <Button variant="ghost" className="flex-1" onClick={() => setIsRejecting(false)} data-id="element-2718">
                        Batal
                      </Button>
                      <Button className="flex-1 bg-red-600 text-white hover:bg-red-700" onClick={handleReject} data-id="element-2719">
                        Kirim Penolakan
                      </Button>
                    </div>
                  </div>}
              </div>

              <div className="text-center" data-id="element-2720">
                <span className="text-xs text-gray-400" data-id="element-2721">
                  Antrian: {currentItemIndex + 1} dari {queue.length}
                </span>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </CommandCenterLayout>;
}